let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gR9lo")).then(() => parcelRequire('fbTE6'));